(function () {
  "use strict";

  if (window.AlAsilDeliveryPromise) return;

  var DEFAULT_TIMEZONE_OFFSET_HOURS = 4;
  var LOCATION_PREF_KEY = "alasil:location-preference:v1";
  var CART_LOCATION_KEY = "cartDeliveryLocation";
  var LOCATION_MAX_AGE = 30 * 86400000;

  function readJson(key) {
    try { return JSON.parse(localStorage.getItem(key) || "null"); } catch (error) { return null; }
  }

  function normalizeArea(value) {
    var normalized = String(value || "")
      .toLowerCase()
      .replace(/[-_]/g, " ")
      .replace(/\s+emirate\s*$/i, "")
      .replace(/^emirate\s+of\s+/i, "")
      .replace(/\s+/g, " ")
      .trim();
    var arabicAliases = {
      "دبي": "dubai",
      "أبوظبي": "abu dhabi",
      "أبو ظبي": "abu dhabi",
      "الشارقة": "sharjah",
      "عجمان": "ajman",
      "رأس الخيمة": "ras al khaimah",
      "الفجيرة": "fujairah",
      "أم القيوين": "umm al quwain"
    };
    return arabicAliases[normalized] || normalized;
  }

  function localizedArea(area, locale, preferredLabel) {
    var normalized = normalizeArea(area);
    if (String(locale || "").toLowerCase().indexOf("ar") !== 0) return preferredLabel || area;
    var labels = {
      "dubai": "دبي",
      "abu dhabi": "أبوظبي",
      "sharjah": "الشارقة",
      "ajman": "عجمان",
      "ras al khaimah": "رأس الخيمة",
      "fujairah": "الفجيرة",
      "umm al quwain": "أم القيوين"
    };
    return labels[normalized] || preferredLabel || area;
  }

  function selectedDeliveryArea(locale) {
    var saved = readJson(CART_LOCATION_KEY);
    var savedAt = Number(saved && saved.savedAt || 0);
    var pref = readJson(LOCATION_PREF_KEY);
    var manualAt = Math.max(Number(pref && pref.areaSelectedAt || 0), Number(pref && pref.areaResolvedAt || 0));
    var resolvedAt = Number(saved && saved.areaResolvedAt || 0);
    var manualIsFresh = manualAt > 0 && Date.now() - manualAt <= LOCATION_MAX_AGE;
    var manualIsNewer = pref && (pref.mode === "manual" || pref.mode === "device") && pref.area && manualIsFresh && manualAt >= resolvedAt;
    if (manualIsNewer) {
      return {
        name: pref.area,
        label: localizedArea(pref.area, locale, pref.areaLabel),
        isDubai: normalizeArea(pref.area) === "dubai",
        source: "manual"
      };
    }
    if (saved && (!savedAt || Date.now() - savedAt <= LOCATION_MAX_AGE)) {
      var savedArea = saved.emirate || saved.city;
      if (savedArea) {
        return {
          name: savedArea,
          label: localizedArea(savedArea, locale),
          isDubai: normalizeArea(savedArea) === "dubai",
          source: "delivery-address"
        };
      }
    }
    return null;
  }

  function parseDatasetNumber(value, fallback) {
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function storeNow(element) {
    var now = new Date();
    var timezoneOffsetHours = parseDatasetNumber(
      element && (element.dataset.deliveryTimezoneOffset || element.dataset.timezoneOffset),
      DEFAULT_TIMEZONE_OFFSET_HOURS
    );
    return new Date(now.getTime() + now.getTimezoneOffset() * 60000 + timezoneOffsetHours * 3600000);
  }

  function parseDays(value) {
    var source = value || "true,true,true,true,true,true,true";
    return source.split(",").map(function (day) { return day.trim() === "true"; });
  }

  function nextDelivery(days, currentDay) {
    for (var offset = 1; offset <= 7; offset += 1) {
      if (days[(currentDay + offset) % 7]) return offset;
    }
    return 1;
  }

  function formatNumber(value, locale) {
    try {
      var language = String(locale || "en").toLowerCase();
      return new Intl.NumberFormat(locale || "en", {
        useGrouping: false,
        numberingSystem: language.indexOf("ar") === 0 ? "arab" : "latn"
      }).format(value);
    } catch (error) {
      return String(value);
    }
  }

  function resolve(element) {
    // A deferred dispatch promise takes precedence over available inventory,
    // Jet promotions, area selection and countdowns.
    var preorder = element.dataset.preorderState;
    if (preorder && preorder !== "none") {
      var start = new Date(element.dataset.preorderStart), end = new Date(element.dataset.preorderEnd);
      var valid = preorder !== "unavailable" && Number.isFinite(start.getTime()) && Number.isFinite(end.getTime()) && start <= end && end.getTime() > Date.now();
      var dispatchRange = "";
      var headline = element.dataset.preorderReviewLabel || "Preorder details need review before checkout.";
      if (valid) {
        var formatter = new Intl.DateTimeFormat(element.dataset.deliveryLocale || document.documentElement.lang || "en", {dateStyle:"medium",timeZone:"Asia/Dubai"});
        dispatchRange = formatter.formatRange ? formatter.formatRange(start,end) : formatter.format(start) + " – " + formatter.format(end);
        headline = (element.dataset.preorderDispatchLabel || "Expected dispatch:") + " " + formatter.format(start) + " – " + formatter.format(end);
      }
      return {code:valid ? "preorder" : "preorder-review",headline:headline,dispatchRange:dispatchRange,countdown:"",pickup:false,destination:"",fee:""};
    }
    var now = storeNow(element);
    var jetStartHour = parseDatasetNumber(element.dataset.deliveryJetStartHour, 10);
    var jetStartMinute = parseDatasetNumber(element.dataset.deliveryJetStartMinute, 0);
    var jetStart = jetStartHour * 60 + jetStartMinute;
    var cutoffHour = parseDatasetNumber(element.dataset.deliveryCutoffHour, 21);
    var cutoffMinute = parseDatasetNumber(element.dataset.deliveryCutoffMinute, 0);
    var cutoff = cutoffHour * 60 + cutoffMinute;
    var current = now.getHours() * 60 + now.getMinutes();
    var days = parseDays(element.dataset.deliveryDays);
    var available = element.dataset.deliveryAvailable !== "false";
    var jet = element.dataset.deliveryJet === "true";
    var locale = element.dataset.deliveryLocale || document.documentElement.lang || "en";
    var selectedArea = selectedDeliveryArea(locale);
    if (selectedArea && !selectedArea.isDubai) jet = false;
    var hourShort = element.dataset.deliveryHourShort || "h";
    var minuteShort = element.dataset.deliveryMinuteShort || "m";
    var beforeCutoff = days[now.getDay()] && current < cutoff;
    /* Jet is an operating-hours service, not merely a "before cutoff"
       promotion. Without the lower boundary, 00:00-09:59 Dubai was treated
       as eligible again immediately after the 21:00 cutoff. */
    var jetWindowOpen = beforeCutoff && current >= jetStart;
    var state = {
      code: "standard",
      headline: element.dataset.deliveryToday,
      countdown: "",
      pickup: available && element.dataset.deliveryShowPickup !== "false",
      destination: selectedArea ? selectedArea.label : element.dataset.deliveryDestination,
      fee: element.dataset.deliveryFree
    };

    if (!available) {
      state.code = "unavailable";
      state.headline = element.dataset.deliverySoldOut;
      state.pickup = false;
      state.destination = "";
      state.fee = "";
      return state;
    }

    if (jet && jetWindowOpen) {
      state.code = "jet";
      state.headline = element.dataset.deliveryJetText;
      return state;
    }

    /* Same-day and Jet are Dubai services. Once the shopper has explicitly
       selected another emirate, use the next enabled delivery day instead of
       continuing to promise Dubai timing with a different destination label. */
    if (selectedArea && !selectedArea.isDubai) {
      var areaOffset = nextDelivery(days, now.getDay());
      state.code = areaOffset === 1 ? "tomorrow" : "next-working-day";
      state.headline = areaOffset === 1 ? element.dataset.deliveryTomorrow : element.dataset.deliveryNextWorkingDay;
      return state;
    }

    if (beforeCutoff) {
      var remaining = Math.max(0, cutoff * 60 - (current * 60 + now.getSeconds()));
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      state.code = "today";
      state.headline = element.dataset.deliveryToday;
      state.countdown = element.dataset.deliveryOrderWithin + " " + formatNumber(hours, locale) + hourShort + " " + formatNumber(minutes, locale) + minuteShort;
      return state;
    }

    var offset = nextDelivery(days, now.getDay());
    state.code = offset === 1 ? "tomorrow" : "next-working-day";
    state.headline = offset === 1 ? element.dataset.deliveryTomorrow : element.dataset.deliveryNextWorkingDay;
    return state;
  }

  function syncCartJetEligibility(element) {
    if (element.dataset.deliveryContext !== "cart") return;
    var drawer = element.closest("cart-drawer") || document.querySelector("cart-drawer");
    if (!drawer) return;
    var items = Array.prototype.slice.call(
      drawer.querySelectorAll("tr.cart-item:not(.cart-item--service-addon)[data-delivery-jet]")
    );
    if (!items.length) return;
    element.dataset.deliveryJet = String(items.every(function (item) {
      return item.dataset.deliveryJet === "true";
    }));
  }

  function updateElement(element) {
    if (!element || !element.dataset) return;
    syncCartJetEligibility(element);
    var stateSource = element;
    var context = element.dataset.deliveryContext;
    var isJetOnlySurface = context === "jet-card" || context === "jet-header" || context === "jet-badge" || context === "jet-option";
    if (context === "jet-card" || context === "jet-header") {
      var productInfo = element.closest("product-info");
      stateSource = (productInfo && productInfo.querySelector('[data-delivery-context="pdp"]')) ||
        document.querySelector('[data-delivery-context="pdp"]') || element;
    }
    var state = resolve(stateSource);
    if (isJetOnlySurface) {
      var jetVisible = state.code === "jet";
      var jetSignature = [state.code, jetVisible].join("|");
      var jetChanged = element.dataset.deliverySignature !== jetSignature;
      element.hidden = !jetVisible;
      element.setAttribute("aria-hidden", jetVisible ? "false" : "true");
      element.dataset.deliveryState = state.code;
      element.dataset.deliveryReady = "true";
      if (jetChanged) {
        element.dataset.deliverySignature = jetSignature;
        element.dispatchEvent(new CustomEvent("deliverypromisechange", { bubbles: true, detail: state }));
      }
      return;
    }
    var movedPdpHost = context === "pdp" ? document.querySelector(".cad-mobile-delivery-info") : null;
    var headline = element.querySelector("[data-delivery-promise-headline]") || element.querySelector("[data-estimate-text]") ||
      (movedPdpHost && movedPdpHost.querySelector("[data-estimate-text]"));
    var countdown = element.querySelector("[data-delivery-promise-countdown]");
    var legacyCountdown = element.querySelector("[data-countdown]");
    var surface = element.querySelector("[data-delivery-promise-surface]");
    var pickup = element.querySelector("[data-delivery-promise-pickup]");
    var pickupSeparator = element.querySelector("[data-delivery-promise-pickup-separator]");
    var legacyPickup = element.querySelector("[data-pickup-badge]");
    var ariaLabel = [state.headline, state.countdown, state.destination, state.fee, state.pickup ? element.dataset.deliveryPickup : ""].filter(Boolean).join(". ");
    var signature = [state.code, state.headline, state.countdown, state.destination, state.fee, state.pickup].join("|");
    var changed = element.dataset.deliverySignature !== signature;

    if (element.dataset.deliveryState !== state.code) element.dataset.deliveryState = state.code;
    /* The PDP estimator keeps its established "Arrives today" summary and
       countdown during Jet hours. Jet changes only the expanded Dubai service
       detail; dedicated Jet banner/badge surfaces still use the Jet headline. */
    var preservePdpEstimatorSummary = context === "pdp" && state.code === "jet";
    var visibleHeadline = preservePdpEstimatorSummary ? element.dataset.deliveryToday : state.headline;
    if (headline && context === "pdp" && state.code === "preorder") {
      if (changed || !headline.querySelector(".delivery-promise__date-range")) {
        var label = document.createElement("span"), range = document.createElement("span");
        label.className = "delivery-promise__date-label";
        label.textContent = (element.dataset.preorderDispatchLabel || "Expected dispatch").replace(/[:：]\s*$/, "");
        range.className = "delivery-promise__date-range";
        range.textContent = state.dispatchRange;
        headline.replaceChildren(label, range);
      }
    } else if (headline && headline.textContent !== visibleHeadline) headline.textContent = visibleHeadline;
    if (countdown) {
      if (countdown.textContent !== state.countdown) countdown.textContent = state.countdown;
      if (countdown.hidden === Boolean(state.countdown)) countdown.hidden = !state.countdown;
    }
    if (legacyCountdown) {
      if (state.countdown && legacyCountdown.getAttribute("aria-label") !== state.countdown) legacyCountdown.setAttribute("aria-label", state.countdown);
      if (!state.countdown && legacyCountdown.hasAttribute("aria-label")) legacyCountdown.removeAttribute("aria-label");
    }
    if (pickup && pickup.hidden === state.pickup) pickup.hidden = !state.pickup;
    if (pickupSeparator && pickupSeparator.hidden === state.pickup) pickupSeparator.hidden = !state.pickup;
    if (legacyPickup && legacyPickup.hidden === state.pickup) legacyPickup.hidden = !state.pickup;
    if (surface) {
      surface.classList.toggle("pcard__fomo-pill--60min", state.code === "jet");
      surface.classList.toggle("pcard__fomo-pill--tomorrow", state.code !== "jet" && state.code !== "unavailable");
      surface.classList.toggle("pcard__fomo-pill--soldout", state.code === "unavailable");
    }
    /* Eligibility classes are useful for data and variant swaps, but must not
       paint the purchase UI as Jet outside the live service window. */
    if (context === "pdp") {
      /* Smart Bundle moves the estimator out of <product-info> and into its
         own .product__info-container purchase panel. Resolve either owner so
         the Jet class follows the live delivery surface after that DOM move. */
      var productInfoRoot = element.closest("product-info") || element.closest(".product__info-container");
      if (productInfoRoot) productInfoRoot.classList.toggle("is-jet-active", state.code === "jet");
    }
    if (context === "sticky") {
      var stickyRoot = element.closest(".sticky-cart");
      if (stickyRoot) stickyRoot.classList.toggle("is-jet-active", state.code === "jet");
    }
    if (element.getAttribute("aria-label") !== ariaLabel) element.setAttribute("aria-label", ariaLabel);
    /* Card and PDP promises depend on the shopper's current store time and
       selected delivery area, which Liquid cannot safely cache into the
       initial HTML. Reveal only after the final headline, countdown and state
       classes have been applied. `visibility` keeps the surface dimensions
       reserved, preventing both misleading copy flashes and layout shift. */
    if (element.dataset.deliveryContext === "card" || element.dataset.deliveryContext === "pdp") {
      if (element.dataset.deliveryReady !== "true") element.dataset.deliveryReady = "true";
      /* Section swaps can preserve data-delivery-ready while restoring the
         server-rendered inline guard. Always remove the guard after resolving
         the current state so AJAX-rendered cards cannot remain invisible. */
      if (element.style.visibility) element.style.removeProperty("visibility");
      if (element.style.opacity) element.style.removeProperty("opacity");
    }
    if (changed) {
      element.dataset.deliverySignature = signature;
      element.dispatchEvent(new CustomEvent("deliverypromisechange", { bubbles: true, detail: state }));
    }
  }

  function updateAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    if (scope.matches && scope.matches("[data-delivery-promise]")) updateElement(scope);
    scope.querySelectorAll("[data-delivery-promise]").forEach(updateElement);
  }

  function refreshVariant(scope, html) {
    if (!scope || !html) return;
    ["pdp", "sticky"].forEach(function (context) {
      var selector = '[data-preorder-slot="' + context + '"]';
      var source = html.querySelector(selector);
      if (!source && context === "sticky") {
        var template = html.querySelector('[data-sticky-preorder-template]');
        source = template && template.content.querySelector(selector);
      }
      if (source) scope.querySelectorAll(selector).forEach(function (target) { target.innerHTML = source.innerHTML; });
    });
    scope.querySelectorAll("[data-preorder-payment-promo]").forEach(function (target) {
      var source = Array.from(html.querySelectorAll("[data-preorder-payment-promo]")).find(function (node) {
        return node.dataset.preorderPaymentPromo === target.dataset.preorderPaymentPromo;
      });
      if (source) target.dataset.preorderState = source.dataset.preorderState;
    });
    ["pdp", "sticky"].forEach(function (context) {
      var selector = '[data-delivery-context="' + context + '"]';
      var source = html.querySelector(selector);
      // Section-only product navigation excludes the global sticky bar.
      // Its purchase terms must follow the new PDP, not the previous product.
      if (!source && context === "sticky") source = html.querySelector('[data-delivery-context="pdp"]');
      if (!source) return;
      scope.querySelectorAll(selector).forEach(function (target) {
        Array.from(target.attributes).forEach(function (attribute) {
          if (attribute.name.indexOf("data-preorder-") === 0) target.removeAttribute(attribute.name);
        });
        Array.from(source.attributes).forEach(function (attribute) {
          // This marker initializes the legacy PDP countdown controller. It
          // is not purchase data: copying it onto the sticky promise makes
          // that controller read missing labels and overwrite the PDP text.
          if (attribute.name === "data-delivery-context" || attribute.name === "data-delivery-signature" || attribute.name === "data-delivery-estimator") return;
          if (attribute.name.indexOf("data-preorder-") === 0 || attribute.name.indexOf("data-delivery-") === 0) target.setAttribute(attribute.name,attribute.value);
        });
        var panel = target.querySelector(".delivery-inline-panel");
        if (panel) panel.hidden = target.dataset.preorderState && target.dataset.preorderState !== "none";
        if (panel && panel.hidden) target.removeAttribute("open");
        updateElement(target);
      });
    });
  }
  window.AlAsilDeliveryPromise = { resolve: resolve, updateElement: updateElement, updateAll: updateAll, refreshVariant: refreshVariant };

  function init() {
    updateAll(document);
    document.addEventListener("alasil:delivery-area-changed", function () { updateAll(document); });
    window.addEventListener("storage", function (event) {
      if (event.key === LOCATION_PREF_KEY || event.key === CART_LOCATION_KEY) updateAll(document);
    });
    setInterval(function () { updateAll(document); }, 30000);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) updateAll(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
